import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('[ErrorBoundary] Caught error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center h-screen bg-figma-panel">
          <div className="text-center space-y-4 p-8">
            <h1 className="text-title-lg font-roboto font-bold text-figma-text">
              Something went wrong
            </h1>
            <p className="text-body font-roboto text-neutral-400">
              An unexpected error occurred. Please try again.
            </p>
            <a
              href="/"
              className="inline-block text-figma-lime hover:underline font-roboto text-body"
            >
              Go back to Explorer
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
